import React from 'react';
import SamPointSelector from '../../../components/SamPointSelector';
import StepActions from '../shared/StepActions';
import StepShell from '../shared/StepShell';
import { pageImage } from '../shared/wizardUtils';

export default function ShowContoursStep({ figure, onUpdateContour, onNext, onCancel }) {
  const image = pageImage(figure);

  if (!image) {
    return (
      <StepShell>
        <div className="alert alert-danger">No page image found.</div>
        <StepActions onCancel={onCancel} />
      </StepShell>
    );
  }

  return (
    <StepShell>
      <h3>Show Contours</h3>
      <div className="alert alert-primary">Verify that the contour is included.</div>
      <div className="row">
        <div className="col-md-6">
          <SamPointSelector
            figure={figure}
            image={image}
            onPoints={(points) => onUpdateContour(figure.id, points)}
          />
        </div>
        <div className="col-md-6 d-flex align-items-center">
          <StepActions onNext={onNext} onCancel={onCancel} className="form-actions" />
        </div>
      </div>
    </StepShell>
  );
}
